import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-justificativa-modal',
  templateUrl: './justificativa-modal.component.html',
  styleUrls: ['./justificativa-modal.component.scss']
})
export class JustificativaModalComponent implements OnInit {
  justificativaForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private modalRef: NzModalRef,
  ) {}

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm(): void {
    this.justificativaForm = this.fb.group({
      textoJustificativa: ['']
    });

    this.textoJustificativaControl.setValidators([Validators.required]);
  }

  salvarObservacoes(): void {
    const textoJustificativa = this.textoJustificativaControl?.value;
    this.modalRef.close(textoJustificativa);
  }

  fecharModal(): void {
    this.modalRef.close();
  }

  get textoJustificativaControl(): any {
    return this.justificativaForm.get('textoJustificativa');
  }
}
